<template>
        <div>
            <app-header></app-header>
            <Row style="margin-top: 40px">
                <Col span="7">
                   &nbsp;
                </Col>
                <Col span="10">
                    <div align="center">
                        <label style="font-family: inherit; font-size: large;">Create A New Project</label>
                    </div>
                    <Form :model="formValidate" label-position="left" ref="formValidate" :rules="ruleValidate" :label-width="100" style="margin-top: 40px">
                            <FormItem label="Name" prop="projectName">
                                <Input v-model="formValidate.projectName" placeholder="Enter project name" clearable></Input>
                            </FormItem>
                            <FormItem label="Description" prop="projectDesc">
                                <Input v-model="formValidate.projectDesc" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..."></Input>
                            </FormItem>
                            <FormItem label="contacts" prop="contacts">
                                <Input v-model="formValidate.contacts" placeholder="Enter contacts" clearable></Input>
                            </FormItem>
                            <FormItem label="E-mail" prop="contactEmail">
                                <Input v-model="formValidate.contactEmail" placeholder="Enter your e-mail" clearable></Input>
                            </FormItem>
                            <FormItem label="Financing" prop="financingTarget">
                                <InputNumber :max="100000000" :min="0" v-model="financingTarget" style="width: 200px"></InputNumber>
                            </FormItem>
                            <FormItem label="White Paper" prop="whitePaper">
                                <Input v-model="formValidate.whitePaper" placeholder="Enter the white paper link" clearable></Input>
                            </FormItem>
                            <FormItem label="Telegram" prop="telegram">
                                <Input v-model="formValidate.telegram" placeholder="Enter telegram link" clearable></Input>
                            </FormItem>
                            <FormItem label="Twitter" prop="twitter">
                                <Input v-model="formValidate.twitter" placeholder="Enter Twitter account" clearable></Input>
                            </FormItem>
                            <!-- <FormItem label="tag" prop="tag">
                                <CheckboxGroup v-model="formValidate.tag" v-for="tag in tagList">
                                    <Checkbox v-model="tag.tagId">{{tag.tagName}}</Checkbox>
                                </CheckboxGroup>
                            </FormItem> -->
                            <FormItem>
                                <Button type="primary" @click="handleSubmit('formValidate')">Submit</Button>
                                <Button @click="handleReset('formValidate')" style="margin-left: 8px">Reset</Button>
                            </FormItem>
                        </Form>
                </Col>
                <Col span="7">
                    <div>
                        &nbsp;
                    </div>
                </Col>
            </Row>
            
        </div>
</template>
<style>
</style>
<script>
    import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                tagList: '',
                formValidate: {
                    projectName: '',
                    financingTarget: '',
                    contacts: '',
                    contactEmail: '',
                    whitePaper: '',
                    telegram: '',
                    twitter: '',
                    tag: [],
                    projectDesc: ''
                },
                ruleValidate: {
                    projectName: [
                        { required: true, message: 'The project name cannot be empty', trigger: 'blur' }
                    ],
                    contacts: [
                        { required: true, message: 'The contacts cannot be empty', trigger: 'blur' }
                    ],
                    whitePaper: [
                        { required: true, message: 'The whitePaper link cannot be empty', trigger: 'blur' }
                    ],
                    telegram: [
                        { required: true, message: 'The telegram link cannot be empty', trigger: 'blur' }
                    ],
                    twitter: [
                        { required: true, message: 'The twitter account cannot be empty', trigger: 'blur' }
                    ],
                    contactEmail: [
                        { required: true, message: 'Mailbox cannot be empty', trigger: 'blur' },
                        { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
                    ],
                    tag: [
                        { required: false, type: 'array', min: 1, message: 'Choose at least one tag', trigger: 'change' },
                        { type: 'array', max: 3, message: 'Choose three tags at best', trigger: 'change' }
                    ],
                    projectDesc: [
                        { required: true, message: 'Please enter a project description', trigger: 'blur' },
                        { type: 'string', min: 20, message: 'Description no less than 20 words', trigger: 'blur' }
                    ]
                }
            }
        },
        created(){
            
        },
        mounted:function(){
            this.getAllTag();
        },
        watch:{
            
        },
        computed: {
            
        },
        methods: {
            
            getAllTag:function(){
                let url = config.baseUrl + "tag/getAllTag";
                this.$http.get(url).then(function(successData){
                    let that = this;
                    let data = successData.data;
                    that.tagList = data;
                },function(errorData){
                    this.$Message.error("Load Fail!");
                });
            },
            handleSubmit (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let url = config.baseUrl + 'project/creation';
                        this.$http.post(url, this.formValidate).then(function(successData){
                            let data = successData.data;
                            //创建成功
                            if(data.resCode == 0){
                                this.$refs[name].resetFields();
                                this.$Notice.info({
                                    title: 'check pending',
                                    desc: "Your project has been successfully created. Please wait for the administrator's approval.",
                                    duration: 0
                                });
                                this.$router.push({name: 'project'});
                                this.$http.get(config.baseUrl + 'project/noticeEmail/' + data.result).then(function(successData){
                                    let data = successData.data;
                                    //邮件发送成功
                                    if (data.resCode == 0) {
                                        this.$Notice.info({
                                        title: 'Notification email was sent successfully',
                                        desc: "We have sent a notification email to the administrator, please wait for review.",
                                    });
                                    }
                                });
                            }
                        },function(errorData){
                            this.$Message.error('Sorry,server exception!');
                        });
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CreateProject.vue?0df3894a